import { Navigate } from "react-router-dom";
import { useRole } from "contexts/RoleContext";

export default function HomeRedirect() {
  const { role } = useRole();
  return <Navigate to={role === "tutor" ? "/tutor/dashboard" : "/dashboard"} replace />;
}
